const USER_INTEREST_API_URL = process.env.GATSBY_ENV.includes('stg') ? 'https://life.stgairasia.com/profile/interest/' : 'https://life.airasia.com/profile/interest/'

const getUserInterest = (urlParam) => {
  return fetch(USER_INTEREST_API_URL + urlParam)
    .then(function (response) {
      return response.json();
    }).catch(error => {
      return error;
    });
}

const saveUserInterest = (urlParam, payload) => {
  return fetch(USER_INTEREST_API_URL + urlParam, {
    method: 'POST', headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }, body: JSON.stringify(payload)
  })
    .then(function (response) {
      if (response.status===200) {
        return response.json();
      }
    }).catch(error => {
      return error;
    });
}

export {getUserInterest, saveUserInterest};
